module.exports = __webpack_public_path__ + "static/media/twitter.35590a7d.svg";